import { isLocalHost } from "shared/util/EnvironmentHelpers";
import LocalEnvironment from "shared/util/LocalEnvironment";

export const SERVER_URL = isLocalHost
	? LocalEnvironment.getEnvironmentUrl()
	: "";
export const API_PREFIX = "/1/apitun";
export const METHODS = {
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE",
};
export const DEFAULT_ERROR = {
	error: {
		message: "Unknown Error",
		type: "DefaultError",
	},
};

export default {
	API_PREFIX,
	METHODS,
	DEFAULT_ERROR,
};



// WEBPACK FOOTER //
// ./src/shared/util/OkcApi/constants.js